module.exports = __webpack_public_path__ + "img/loginbgcPic.e124bd63.jpg";